// Como escrever, em uma linha, o horário de atendimento e o estado dele.
//
// A CONTA não mora aqui: quem decide se está aberto, quando fecha e quando
// volta a abrir é o backend (`estadoDoHorario`, em
// `services/WhatsappService/AvisoAutomaticoService.ts`) — duas contas para a
// mesma pergunta acabariam com a tela dizendo uma coisa e o robô fazendo
// outra. Aqui é só texto.

const CURTOS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

const ORDEM = [1, 2, 3, 4, 5, 6, 0];

// Lê o formato novo (faixas) e o antigo (abre/fecha soltos), como o backend.
export const faixasDoDia = (h) => {
	if (!h) return [];

	if (Array.isArray(h.faixas) && h.faixas.length) {
		return h.faixas.filter((f) => f?.abre && f?.fecha);
	}

	return h.abre && h.fecha ? [{ abre: h.abre, fecha: h.fecha }] : [];
};

const textoDasFaixas = (faixas) =>
	faixas.map((f) => `${f.abre}–${f.fecha}`).join(" e ");

// "Seg–Sex 08:00–12:00 e 13:30–18:00 · Sáb 09:00–13:00 · Dom fechado".
//
// Dias seguidos com o mesmo horário viram faixa de dias: listar os sete um a
// um é o tipo de resumo que ninguém lê.
export const resumoSemanal = (horarios) => {
	const lista = Array.isArray(horarios) ? horarios : [];

	if (!lista.length) return "Atende a qualquer hora";

	const porDia = ORDEM.map((dia) => {
		const h = lista.find((item) => Number(item.dia) === dia);
		const faixas = h?.aberto ? faixasDoDia(h) : [];

		return {
			dia,
			// Dia aberto e sem faixa legível atende o dia inteiro — é o que o
			// backend faz, e o resumo não pode prometer outra coisa.
			texto: h?.aberto
				? faixas.length
					? textoDasFaixas(faixas)
					: "24h"
				: "fechado",
		};
	});

	const grupos = [];

	porDia.forEach((item) => {
		const ultimo = grupos[grupos.length - 1];

		if (ultimo && ultimo.texto === item.texto) ultimo.fim = item.dia;
		else grupos.push({ inicio: item.dia, fim: item.dia, texto: item.texto });
	});

	return grupos
		.map(({ inicio, fim, texto }) => {
			const dias =
				inicio === fim
					? CURTOS[inicio]
					: `${CURTOS[inicio]}–${CURTOS[fim]}`;

			return `${dias} ${texto}`;
		})
		.join(" · ");
};

// "Aberto agora · fecha às 18:00" / "Fora do expediente · abre seg 08:00".
export const resumoDoEstado = (estado, hojeDiaSemana) => {
	if (!estado) return "";

	if (estado.motivo === "sem_horario") return "Atende a qualquer hora";

	if (estado.aberto) {
		return estado.fechaAs
			? `Aberto agora · fecha às ${estado.fechaAs}`
			: "Aberto agora";
	}

	const abertura = estado.proximaAbertura;

	const inicio =
		estado.motivo === "ferias"
			? "Em férias coletivas"
			: estado.motivo === "feriado"
				? "Fechado por feriado"
				: "Fora do expediente";

	if (!abertura) return `${inicio} · sem próxima abertura cadastrada`;

	const hoje =
		typeof hojeDiaSemana === "number" && hojeDiaSemana === abertura.diaSemana;

	return `${inicio} · abre ${
		hoje ? "hoje" : CURTOS[abertura.diaSemana]?.toLowerCase()
	} ${abertura.hora}`;
};

export default resumoDoEstado;
